/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { Building2, Landmark, RefreshCw, Send } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j08-s06-exportar-efetivar';
const moeda = (v: any) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export function ExportarEfetivarPagamentoPage() {
  const [s, setS] = useState<any>(),
    [busy, setBusy] = useState(false);
  async function call(p: string, b?: any) {
    setBusy(true);
    try {
      const e = await chamarApi<any>(NS + p, { metodo: p === '/state' ? 'GET' : 'POST', corpo: b });
      setS(e.state);
    } finally {
      setBusy(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando exportações…
      </main>
    );
  const lote = s.lotes[0],
    e = s.exportacoes[0];
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <header>
        <h1 className="text-3xl font-semibold">
          <Building2 className="mr-2 inline h-7 w-7" />
          {s.titulo}
        </h1>
        <p>{s.descricao}</p>
        <p className="text-sm text-muted-foreground">
          Sessão: {s.sessao?.nome} · {s.sessao?.email}
        </p>
      </header>
      {s.alertas.map((a: any) => (
        <div key={a.codigo} role="alert" className="rounded-md border border-destructive p-3">
          {a.mensagem} <span className="font-mono text-xs">{a.codigo}</span>
        </div>
      ))}
      {lote && (
        <section className="rounded-md border p-4">
          <h2 className="font-semibold">Lote autorizado</h2>
          <p>
            {lote.numero} · {moeda(lote.valor)}
          </p>
          <p className="break-all font-mono text-xs">{lote.id}</p>
          {!e && (
            <Button
              disabled={busy}
              onClick={() =>
                void call('/verbs/exportar_lote', {
                  loteId: lote.id,
                  chaveIdempotencia: `exportar-${lote.id}`,
                })
              }
            >
              <Send className="mr-2 h-4 w-4" />
              Exportar lote
            </Button>
          )}
        </section>
      )}
      {e && (
        <section className="space-y-3 rounded-md border p-4">
          <h2 className="font-semibold">Exportação {e.estado}</h2>
          <p>
            Arquivo <span className="break-all font-mono text-xs">{e.arquivo_hash}</span>
          </p>
          <p>Correlação: {e.correlacao_orcamentaria}</p>
          <p>Protocolo: {e.protocolo_externo ?? 'aguardando retorno'}</p>
          <div className="space-y-2">
            {e.itens.map((i: any) => (
              <article key={i.id} className="rounded border p-3">
                <strong>
                  Item {i.sequencia}: {moeda(i.valor)} · {i.estado}
                </strong>
                <p>ID externo: {i.identificador_externo ?? 'aguardando'}</p>
                {i.motivo_rejeicao && <p>Exceção: {i.motivo_rejeicao}</p>}
                {i.movimento && (
                  <p>
                    Movimento {i.movimento.identificador_externo} · {i.movimento.estado} ·{' '}
                    {i.movimento.ocorrido_em}
                  </p>
                )}
              </article>
            ))}
          </div>
          <Button
            variant="outline"
            disabled={busy}
            onClick={() =>
              void call('/verbs/exportar_lote', {
                loteId: lote.id,
                chaveIdempotencia: `exportar-${lote.id}`,
              })
            }
          >
            <Send className="mr-2 h-4 w-4" />
            Reenviar lote com idempotência
          </Button>
          {e.estado === 'ENVIADO' && (
            <Button
              disabled={busy}
              onClick={() =>
                void call('/verbs/consultar_retorno_orcamentario', { exportacaoId: e.id })
              }
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Consultar retorno orçamentário
            </Button>
          )}
          {['ACEITO', 'REJEITADO_PARCIAL'].includes(e.estado) && !e.operacaoBancaria && (
            <Button
              disabled={busy}
              onClick={() =>
                void call('/verbs/solicitar_efetivacao_bancaria', {
                  exportacaoId: e.id,
                  chaveIdempotencia: `banco-${e.id}`,
                })
              }
            >
              <Landmark className="mr-2 h-4 w-4" />
              Solicitar efetivação bancária
            </Button>
          )}
          {e.operacaoBancaria && e.operacaoBancaria.estado === 'PENDENTE' && (
            <Button
              disabled={busy}
              onClick={() => void call('/verbs/consultar_retorno_bancario', { exportacaoId: e.id })}
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Consultar movimentos bancários
            </Button>
          )}
        </section>
      )}
    </main>
  );
}
